import React from "react";
import { SchedulerViewComponentProps } from "../../types/views";
import TimeGridView from "../Calendar/TimeGridView";

const WeekView: React.FC<SchedulerViewComponentProps> = ({
  events,
  currentDate,
  startHour,
  endHour,
  onEventClick,
  onTimeSlotClick,
  viewConfig,
  schedulerTheme,
}) => {
  return (
    <TimeGridView
      events={events}
      currentDate={currentDate}
      daysToShow={7}
      startHour={startHour}
      endHour={endHour}
      onEventClick={onEventClick}
      onTimeSlotClick={onTimeSlotClick}
      viewConfig={viewConfig}
      schedulerTheme={schedulerTheme}
    />
  );
};

export default WeekView;
